export enum CustomerSettingType {
    List = 'List',
    Object = 'Object',
    String = 'String',
    Password = 'Password',
    Boolean = 'Boolean',
    Number = 'Number',
}

export type CustomerSetting = {
    _id?: string;
    name: string;
    type: string;
    value?: unknown;
    category?: string;
    description?: string;
    values?: unknown[];
    selectedValue?: unknown;
    preSelectedValue?: unknown;
    defaultValue?: unknown;
};
